import axios from 'axios';

import appSettings from '../app-settings';

const API_URL = `${appSettings.baseUrl}/accounts/subscription`;
const ACCOUNTS_URL = `${appSettings.baseUrl}/accounts`;

export const getInvoices = async () => {
  const res = await axios.get(`${API_URL}/invoices`);
  return res.data;
};

export const createCheckoutSetupSession = async () => {
  const res = await axios.post(`${ACCOUNTS_URL}/checkout-setup`);
  return res.data;
};
